import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const MenuIcon = ({ className = '', width = 15,  height = 13 , color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={height}
            viewBox='0 0 15 13'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M15 1H0V0H15V1ZM15 7H0V6H15V7ZM0 13H15V12H0V13Z'
                fill={color}
                fillRule='evenodd' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default MenuIcon;
